import React, { useState } from 'react';
import { AlertDialog } from '../../../UI/AlertDialog';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../../../../customHooks/useWindowSize';
import API_REST from '../../../../api-rest-uruk';
import GraphqlApi from '../../../../api-graphql';
import LoadingCard from '../../../UI/LoadingCard';
import MobileMenuItem from './MobileMenuItem';
import CardButton from './CardButton';
import { connect } from 'react-redux';
import { getDocuments } from '../../../../actions';

const DocumentMenu = (props) => {
  const { document, fetchFiles } = props;
  const { flowId, id } = document;
  const windowSize = useWindowSize();
  const [deleteFlowDialog, setDeleteFlowDialog] = useState(false);
  const [cancelFlowDialog, setCancelFlowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { t } = useTranslation();
  const DESKTOP_WIDTH = 1330;

  const handleCancelFlow = async (choise) => {
    setDeleteFlowDialog(false);
    if (choise) {
      setMessage(t('documentMenu:canceling'));
      setLoading(true);
      API_REST.cancelFlow({ flowId, documentId: id })
        .then(async () => {
          await fetchFiles();
          setMessage(t('documentMenu:ready'));
          setTimeout(() => setLoading(false), 2000);
        })
        .catch((err) => {
          console.error(err);
          setMessage(t('documentMenu:error'));
          setTimeout(() => setLoading(false), 2000);
        });
    }
  };

  const handleDeleteDocument = async (choise) => {
    document.status = 'deleted';
    setDeleteFlowDialog(false);
    if (choise) {
      setMessage(t('documentMenu:delete'));
      setLoading(true);
      await GraphqlApi.updateDocument(document)
        .then(async () => {
          await fetchFiles();
          setMessage(t('documentMenu:ready'));
          setTimeout(() => setLoading(false), 2000);
        }).catch((err) => {
          console.error(err);
          setMessage(t('documentMenu:error'));
          setTimeout(() => setLoading(false), 2000);
        });
    }
  };

  return (
    <>
      {
        windowSize.width >= DESKTOP_WIDTH
          ? <CardButton
            document={document}
            handleCancelFlow={setCancelFlowDialog}
            handleDeleteFlow={setDeleteFlowDialog}
          />
          : <MobileMenuItem
            document={document}
            setCancelFlowDialog={setCancelFlowDialog}
            setDeleteFlowDialog={setDeleteFlowDialog}
          />
      }
      {cancelFlowDialog &&
        <AlertDialog
          description={t('documentMenu:cancelConfirmationMessage')}
          callbackFunc={handleCancelFlow}
          open={cancelFlowDialog}
          setOpen={setCancelFlowDialog}
        />}
      {deleteFlowDialog &&
        <AlertDialog
          description={t('documentMenu:deleteConfirmationMessage')}
          callbackFunc={handleDeleteDocument}
          open={deleteFlowDialog}
          setOpen={setDeleteFlowDialog}
        />}
      <LoadingCard open={loading} loading={loading} message={message} />
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFiles: () =>
      dispatch(getDocuments())
  };
};

export default connect(null, mapDispatchToProps)(DocumentMenu);
